import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import 'parsleyjs';
import Select from '../../../../../components/Select/index';
import MaskedInput from 'react-text-mask';
import { USD_WITH_DECIMAL_ATTR } from '../../../../../services/constant/constant';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

const usdWithDecimalMask = createNumberMask(USD_WITH_DECIMAL_ATTR);

class ClientForm extends Component {
    constructor(props) {
        super(props);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleMaskedInputChange = this.handleMaskedInputChange.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.updateAddNewClientData = this.updateAddNewClientData.bind(this);
    }

    updateAddNewClientData(client) {
        let { updateClientData } = this.props;
        updateClientData(client);
    }

    handleInputChange(event) {
        let { clientData, isEditable } = this.props;
        if (isEditable) {
            const target = event.target;
            const value =
                target.type === 'checkbox' ? target.checked : target.value;
            const name = target.name;

            let tmpSelected = _.extend({}, clientData);
            tmpSelected[name] = value;
            this.updateAddNewClientData(tmpSelected);
        }
    }

    handleMaskedInputChange(event) {
        let { clientData, isEditable } = this.props;
        if (isEditable) {
            const target = event.target;
            const value =
                target.value === ''
                    ? target.value
                    : parseFloat(target.value.replace(/,|\$/g, ''));
            const name = target.name;
            let tmpSelected = _.extend({}, clientData);
            tmpSelected[name] = value;
            this.updateAddNewClientData(tmpSelected);
        }
    }

    handleSelectChange(name, value) {
        let { clientData } = this.props;
        let tmpSelected = _.extend({}, clientData);
        if (value !== null) {
            tmpSelected[name] = value[name];
        } else {
            tmpSelected[name] = '';
        }
        this.updateAddNewClientData(tmpSelected);
    }

    render() {
        let { clientData, countryList, isEditable, formRef } = this.props;
        return (
            <form ref={formRef}>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Name</label>
                        <input
                            className="form-control"
                            type="text"
                            name="name"
                            value={clientData.name}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                            data-parsley-required
                            data-parsley-maxlength="200"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Contact Name</label>
                        <input
                            className="form-control"
                            type="text"
                            name="contactName"
                            value={clientData.contactName}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                            data-parsley-maxlength="200"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Address-1</label>
                        <input
                            className="form-control"
                            type="text"
                            name="address1"
                            value={clientData.address1}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                            data-parsley-maxlength="100"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>Address-2</label>
                        <input
                            className="form-control"
                            type="text"
                            name="address2"
                            value={clientData.address2}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                            data-parsley-maxlength="100"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-6">
                        <label>Country</label>
                        <Select
                            name="countryId"
                            labelKey="name"
                            valueKey="countryId"
                            options={countryList}
                            selectedValue={clientData.countryId}
                            onChange={this.handleSelectChange}
                            disabled={!isEditable}
                            required={true}
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <label>City</label>
                        <input
                            className="form-control"
                            type="text"
                            name="city"
                            value={clientData.city}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-6">
                        <label>State</label>
                        <input
                            className="form-control"
                            type="text"
                            name="state"
                            value={clientData.state}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                            data-parsley-maxlength="2"
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <label>Zip Code</label>
                        <input
                            className="form-control"
                            type="text"
                            name="postalCode"
                            value={clientData.postalCode}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                            data-parsley-maxlength="10"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-6">
                        <label>Service Fee</label>
                        <MaskedInput
                            mask={usdWithDecimalMask}
                            className="form-control"
                            type="text"
                            name="serviceFee"
                            value={clientData.serviceFee}
                            onChange={this.handleMaskedInputChange}
                            disabled={!isEditable}
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <label>Other Fee</label>
                        <MaskedInput
                            mask={usdWithDecimalMask}
                            className="form-control"
                            type="text"
                            name="otherFee"
                            value={clientData.otherFee}
                            onChange={this.handleMaskedInputChange}
                            disabled={!isEditable}
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <label>Priority Service Fee</label>
                        <MaskedInput
                            mask={usdWithDecimalMask}
                            className="form-control"
                            type="text"
                            name="priorityServiceFee"
                            value={clientData.otherFee}
                            onChange={this.handleMaskedInputChange}
                            disabled={!isEditable}
                        />
                    </div>
                </div>
            </form>
        );
    }
}

ClientForm.propTypes = {
    clientData: PropTypes.object.isRequired,
    countryList: PropTypes.array.isRequired,
    stateList: PropTypes.array.isRequired,
    updateClientData: PropTypes.func,
    isEditable: PropTypes.func.bool
};

ClientForm.defaultProps = {
    isEditable: true
};

export default ClientForm;



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/ClientInformation/components/ClientForm.js